import { render, staticRenderFns } from "./ScholarshipsAssign.vue?vue&type=template&id=e2b64488"
import script from "./ScholarshipsAssign.vue?vue&type=script&lang=js"
export * from "./ScholarshipsAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports